/*
 * Próbki kolorów na kartach produktów: klik podmienia zdjęcie karty
 * zamiast przenosić na stronę produktu.
 *
 * Link zostaje prawdziwym <a> z adresem wariantu — dzięki temu działa
 * otwarcie w nowej karcie, indeksowanie i nawigacja klawiaturą. Przechwytujemy
 * dopiero zwykły klik (bez Ctrl/Cmd/środkowego przycisku), a przy okazji
 * przestawiamy adres całej karty na wybrany wariant, żeby klient trafił
 * dokładnie na to, co widzi.
 */
(function () {
  document.addEventListener('click', function (zdarzenie) {
    if (zdarzenie.metaKey || zdarzenie.ctrlKey || zdarzenie.shiftKey || zdarzenie.button !== 0) return;

    var probka = zdarzenie.target.closest('.card-swatches__link');
    if (!probka) return;

    var karta = probka.closest('.card-wrapper');
    var duze = probka.getAttribute('data-probka-duze');
    if (!karta || !duze) return;

    var obraz = karta.querySelector('.card__media img, .card__inner img');
    if (!obraz) return;

    zdarzenie.preventDefault();

    // srcset i sizes muszą zniknąć — inaczej przeglądarka dalej wybiera
    // z nich stary plik i podmiana `src` nie daje żadnego efektu.
    obraz.removeAttribute('srcset');
    obraz.removeAttribute('sizes');
    obraz.src = duze;

    karta.querySelectorAll('.card-swatches__link').forEach(function (el) {
      el.classList.toggle('card-swatches__link--wybrana', el === probka);
    });

    var adres = probka.getAttribute('href');
    if (adres) {
      karta.querySelectorAll('a.full-unstyled-link').forEach(function (el) {
        el.setAttribute('href', adres);
      });
    }
  });
})();
